import { createRootSelector } from '@mui/x-data-grid-pro/internals';
export const gridCellSelectionStateSelector = createRootSelector(state => state.cellSelection);